export default "__VITE_ASSET__DzapfRlg__"